<template>
  <q-card class="i-statistics-panel">
    <q-card-section class="i-statistics-panel-head">
      <div class="panel-title" style="width:10em">{{computedStatisticsType.text}}</div>
      <q-option-group v-model="selectedDatePeriod" :options="computedDatePeriods" color="primary" inline size="xs" :disable="loading" />
      <q-option-group v-model="selectedNumberDimension" :options="computedNumberDimensions" color="primary" inline size="xs" :disable="loading" />
      <q-option-group v-model="selectedGroup" :options="computedGroupOptions" color="primary" inline size="xs" :disable="loading" />
      <q-btn icon="refresh" flat round :disable="loading" :loading="loading" />
    </q-card-section>
    <q-card-section class="i-statistics-panel-body">
      <div class="statistics-pie">
      </div>
      <div class="statistics-axis">
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import { StatisticsType, StatisticsDatePeriod, StatisticsNumberDimension } from '@/lib/enums'
import * as echarts from 'echarts'
import _ from 'lodash'

export default {
  data () {
    return {
      selectedDatePeriod: null,
      selectedNumberDimension: null,
      selectedGroup: null,
      rows: null,
      loading: false
    }
  },
  props: {
    statisticsType: {
      type: Number,
      require: true
    },
    datePeriods: {
      type: Array
    },
    defaultDatePeriod: {
      type: Number
    },
    numberDimensions: {
      type: Array
    },
    defaultNumberDimension: {
      type: Number
    },
    groupOptions: {
      type: Array,
      require: true
    },
    defaultGroup: {
      type: String
    }
  },
  computed: {
    computedStatisticsType () {
      return StatisticsType.getItem(this.statisticsType)
    },
    computedDatePeriods () {
      return this.datePeriods?.map(item => StatisticsDatePeriod.getItem(item)) ?? StatisticsDatePeriod.items
    },
    computedNumberDimensions () {
      return this.numberDimensions?.map(item => StatisticsNumberDimension.getItem(item)) ?? StatisticsNumberDimension.items
    },
    computedGroupOptions () {
      return this.groupOptions.map(item => ({
        ...item,
        name: item.name ?? item.field,
        field: item.field ?? item.name,
        label: item.label ?? item.text,
        text: item.text ?? item.label,
        value: item.field ?? item.name
      }))
    },
    loadParams () {
      return {
        type: _.camelCase(this.computedStatisticsType.name),
        filters: {
          period: this.selectedDatePeriod,
          periodStart: -6,
          periodEnd: 0
        },
        group: {
          by: this.computedGroupOptions.map(group => group.field)
        }
      }
    }
  },
  mounted () {
    this.reset()
    this.refreshPie()
    this.refreshAxis()
  },
  methods: {
    reset () {
      this.selectedDatePeriod = this.defaultDatePeriod ?? this.computedDatePeriods[0]?.value
      this.selectedNumberDimension = this.defaultNumberDimension ?? this.computedNumberDimensions[0]?.value
      this.selectedGroup = this.defaultGroup ?? this.computedGroupOptions[0]?.value
    },
    async load () {
      this.loading = true
      const searchResult = this.$$api.bis.post('/system/statistics', this.loadParams)
      this.loading = false
      searchResult.notifyIfFail()
      if (searchResult.success) {
        this.rows = searchResult.data.rows
      }
    },
    refreshPie () {
      const chartEl = this.$el.querySelector('.statistics-pie')
      const chart = echarts.init(chartEl)
      // 绘制图表
      chart.setOption({
      // title: {
      //   text: '血型分类统计',
      //   // subtext: 'Fake Data',
      //   left: 'center'
      // },
        tooltip: {
          trigger: 'item'
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 'left'
        // },
        series: [
          {
            name: '血型分类统计',
            type: 'pie',
            radius: '90%',
            data: [
              { value: 210, name: 'A(210袋)' },
              { value: 310, name: 'B(310袋)' },
              { value: 410, name: 'O(410袋)' },
              { value: 320, name: 'AB(320袋)' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    },
    refreshAxis () {
      const chartEl = this.$el.querySelector('.statistics-axis')
      const chart = echarts.init(chartEl)
      chart.setOption({
        // title: {
        //   text: 'Stacked Line'
        // },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['A', 'B', 'O', 'AB']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['2022-06-29', '2022-06-30', '2022-07-01', '2022-07-02', '2022-07-03', '2022-07-04', '2022-07-05']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'A',
            type: 'line',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: 'B',
            type: 'line',
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: 'O',
            type: 'line',
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: 'AB',
            type: 'line',
            data: [320, 332, 301, 334, 390, 330, 320]
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss">
.i-statistics-panel {
  margin: 1em;
  &-head {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    padding: 0.5em 1em;
  }
  &-body {
    width: 100%;
    height: 200px;
    padding: 1em 0;
    display: flex;
    flex-flow: row nowrap;
  }
  .statistics-pie {
    width: 30%;
  }
  .statistics-axis {
    width: 70%;
  }
}
</style>
